import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetHistoryWithdrawals = (id) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params: id,
                method: 'get',
                url: urls.GET_LIST_WITHDRAWAL
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetWithdrawalsAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetHistoryWithdrawals as SetGetHistoryWithdrawals
}